import { TextProps } from './styleModels';
import { MultiLanguageText } from './MultiLanguageText';

export class TagsItem {
  constructor(item = {}) {
    this.guid = item.guid || '-1';
    this.name = new MultiLanguageText(item.name);
    this.abbreviation = new MultiLanguageText(item.abbreviation);
    this.image = item.image || '';
    this.tagTitleProps = new TextProps(
      item.tagTitleProps || {}
    );
  }
}
